import React from 'react'
import { UploadedPatientType } from '../utils/types'
import './index.less'

interface PatientToUploadTableProps {
  patients: UploadedPatientType[]
  t: (key: string, ctxt?: { [key: string]: string }) => string
}

export const PatientToUploadTable = ({ patients, t }: PatientToUploadTableProps) => {
  return (
    <div className="PatientToUploadTable">
      <div className="PatientToUploadTable__scrollContainer">
        <div className="PatientToUploadTable__scrollContent">
          <div className="PatientToUploadTable__scrollContent__head">
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.firstName')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.lastName')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.ssin')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.idCardNumber')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.email')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.dateOfBirth')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.birthSex')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.statusTags')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.streetAddress')}</span>
            </div>
            <div className="PatientToUploadTable__scrollContent__head__cell">
              <span>{t('modalImportPatients.uploadedPatientsTable.postalAddress')}</span>
            </div>
          </div>
          <div className="PatientToUploadTable__scrollContent__body">
            {patients?.map((patient: UploadedPatientType, index: number) => {
              return (
                <div key={index} className="PatientToUploadTable__scrollContent__body__row">
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.firstName}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.lastName}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.ssin}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.idCardNumber}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.email}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.dateOfBirth}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.birthSex}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.statusTags}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.streetAddress}</span>
                  </div>
                  <div className="PatientToUploadTable__scrollContent__body__row__cell">
                    <span>{patient.postalAddress}</span>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
